import React, { FC, useRef } from 'react'
import { InputComponent } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { Validators } from 'Modules'
import { SpecialInputPropsModel } from 'LibNeo/models'
import { normalizePhone, onlyDigits } from 'Helpers'

const MASK = '+7 (###) ###-##-##'
const MASK_CHAR = '_'

export const normalizePhoneMask = (value: string): string => {
	let output = MASK
	const valueDigits = onlyDigits(value)
	const firstIndex = valueDigits?.[0] === '7' || valueDigits?.[0] === '8' ? 1 : 0
	for (let i = firstIndex; i < valueDigits.length; i += 1) {
		output = output.replace('#', valueDigits[i])
	}
	return value ? output.replace(/#/g, MASK_CHAR) : ''
}

export const PhoneInput: FC<SpecialInputPropsModel> = (props) => {
	const inputRef = useRef<{ input: HTMLInputElement }>(null)

	const onChangeInput = (value: string) => {
		if (value === MASK.replace(/#/g, MASK_CHAR)) {
			setTimeout(() => {
				inputRef.current?.input.setSelectionRange(2, 2)
			}, 0)
		}
		props.onChange?.(value)
	}

	return (
		<InputComponent
			{...props}
			fieldName={props?.fieldName || FieldNames.PHONE}
			fieldOptions={{
				rules: [
					{
						validator: Validators.checkPhone({
							required: props?.required,
							messageError: props?.messageError,
						}),
					},
				],
				initialValue: props?.initialValue,
				normalize: normalizePhone,
			}}
			dataQa={props?.dataQa || 'phone-input'}
			placeholder={props.placeholder ?? 'lib.phone'}
			label={props?.hiddenLabel ? null : props?.label ?? 'lib.phone_label'}
			format={normalizePhoneMask}
			mask={MASK_CHAR}
			getInputRef={inputRef}
			onChange={onChangeInput}
		/>
	)
}
